<div class="buttonPanel mat-elevation-z3">
  <span>
    <button
      mat-button
      (click)="closeDialog(undefined)"
      [disabled]="disableButtons()"
    >
      <mat-icon>keyboard_backspace</mat-icon>
      @if (!isHandset()) {
        <span>{{ 'Generic.back' | translate }}</span>
      }
    </button>
  </span>
  <mat-divider></mat-divider>
  <span>
    <button
      mat-button
      (click)="changeScannerMode()"
      [disabled]="disableButtons()"
    >
      <mat-icon>blur_on</mat-icon>
      @if (!isHandset()) {
        <span>{{ 'Generic.scannerChange' | translate }}</span>
      }
    </button>
  </span>
</div>
@if (cameraScannerModeActive()) {
  <app-qrcode-scanner-camera
    #cameraComponent
    (submitCode)="closeDialog($event)"
  ></app-qrcode-scanner-camera>
} @else {
  <div class="message-container">
    <h1>{{ 'Generic.performScan' | translate }}</h1>
  </div>
  <br />
  <input
    matInput
    #scanInput
    [(ngModel)]="beamCode"
    (ngModelChange)="closeDialog($event)"
    style="opacity: 0"
  />
}
